import { IconInfoCircle } from '@tabler/icons-react'

import { AstraIcon, AstraParagraph } from '~/astra'

import { UserFeedbackMetadataProps } from './utils/useUserSupportMetadata'

export const AutoSubmittedInfo = ({ fullName, username, departmentLabel, pageTitle, heroVersion, browserVersion }: UserFeedbackMetadataProps) => {
    const items = [
        { label: 'Navn', value: fullName },
        { label: 'Brukernavn', value: username },
        { label: 'Rapportert fra (side)', value: pageTitle },
        { label: 'Avdeling', value: departmentLabel },
        { label: 'Versjon', value: heroVersion.tag || '–' },
        { label: 'Nettleser', value: browserVersion },
    ]

    return (
        <div className="flex w-full flex-col justify-between gap-6 rounded-lg bg-surface-strong p-6 sm:w-56 sm:shrink-0">
            <div className="flex flex-col gap-3">
                {items.map(({ label, value }) => (
                    <div key={label} className="flex flex-col gap-0.5">
                        <AstraParagraph variant="body-small" weight="medium" className="text-default">
                            {label}
                        </AstraParagraph>
                        <AstraParagraph variant="body-small" className="break-all text-default">
                            {value}
                        </AstraParagraph>
                    </div>
                ))}
            </div>
            <AstraParagraph variant="body" className="flex items-start gap-2 text-default">
                <span className="mt-0.5">
                    <AstraIcon icon={IconInfoCircle} />
                </span>
                Dette vil automatisk bli vedlagt i skjema.
            </AstraParagraph>
        </div>
    )
}
